import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import NHCLogo from '@design/NHCLogo';
import { patientAuthFlow } from '../../auth/patientAuthFlow';

export default function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    if (patientAuthFlow.isOnboardingComplete()) {
      navigate('/patient', { replace: true });
      return;
    }
    const s = patientAuthFlow.getState();
    if (s.approvalStatus === 'pending') {
      const timer = setTimeout(() => navigate('/patient/approval-pending', { replace: true }), 2800);
      return () => clearTimeout(timer);
    }
    if (s.approvalStatus === 'rejected' || s.approvalStatus === 'need_update') {
      const timer = setTimeout(() => navigate('/patient/verification-update-required', { replace: true }), 2800);
      return () => clearTimeout(timer);
    }
    const timer = setTimeout(() => {
      navigate('/patient/entry', { replace: true });
    }, 2800);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: '100dvh',
        background: `linear-gradient(170deg, ${T.navyDk} 0%, ${T.overlap} 55%, ${T.teal} 100%)`,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        position: 'relative',
        overflow: 'hidden',
        fontFamily: T.font,
      }}
    >
      {/* Subtle ECG line across width */}
      <svg width="390" height="60" viewBox="0 0 390 60" fill="none" style={{ position: 'absolute', top: '50%', left: 0, transform: 'translateY(60px)', opacity: 0.12 }}>
        <path d="M0,30 L80,30 L100,30 L120,30 L140,30 L155,30 L165,48 L180,6 L195,48 L205,30 L220,30 L260,30 L300,30 L340,30 L390,30" stroke="#FFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>

      <NHCLogo w={90} variant="white" />
      <div style={{ fontSize: 26, fontWeight: 800, color: '#FFF', fontFamily: T.font, letterSpacing: '-0.02em', marginTop: 6 }}>
        NeoHealthCard™
      </div>
      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.8)', fontFamily: T.font, letterSpacing: '0.02em', textAlign: 'center', padding: '0 40px', lineHeight: 1.6, marginTop: 4 }}>
        Transforming Healthcare with Security, Intelligence, and Care.
      </div>
      <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.6)', fontFamily: T.font, letterSpacing: '0.02em', textAlign: 'center', padding: '0 36px', lineHeight: 1.7, marginTop: 2 }}>
        One connected health identity for patients, doctors, providers, emergency care, and verified records.
      </div>
      {/* Loading bar */}
      <div style={{ width: 160, height: 3, borderRadius: 2, background: 'rgba(255,255,255,0.12)', marginTop: 30, overflow: 'hidden' }}>
        <div
          style={{
            width: '60%',
            height: '100%',
            borderRadius: 2,
            background: 'linear-gradient(90deg, rgba(255,255,255,0.2), rgba(255,255,255,0.7))',
            animation: 'loadPulse 1.5s ease-in-out infinite',
          }}
        />
      </div>
      <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.45)', fontFamily: T.font, textAlign: 'center', padding: '0 32px', lineHeight: 1.7, marginTop: 20 }}>
        Secure health identity · Consent-based records · Verified care network
      </div>
      <style>{`@keyframes loadPulse { 0%{transform:translateX(-100%)} 100%{transform:translateX(180%)} }`}</style>
    </div>
  );
}
